export default __webpack_public_path__ + "static/media/loopback.be536142.jpg";